import './App.css';
import Footer from './Components/Footer';
import Navigation from './Components/Navigation';
import About from './Pages/About';
import Home from './Pages/Home';
import {Routes, Route } from "react-router-dom";
import Registration from './Pages/Registration';
import Contact from './Pages/Contact';


function App() {
  return (
    <div className="App">
      
      <header>
        <Navigation></Navigation>
      </header>
      
      {/* <Routes>
        <Route path='/' component={Home}/>
        <Route path='/About' component={About}/>
        <Route path='/Registration' component={Registration}/>
        <Route path='/Contact' component={Contact}/>
      </Routes> */}

      <Routes>
        <Route path="/" Component={Home}></Route>
        <Route path="/About" Component={About}></Route>
        <Route path='/Registration' Component={Registration}></Route>
        <Route path='/Contact' Component={Contact}></Route>
      </Routes>
      
      <footer>
        <Footer></Footer>
      </footer>
    </div>
  );
}

export default App;
